export function omit <T, K extends keyof any> (obj: T, keys: K[]): Pick<T, Exclude<keyof T, K>> {
    const ret: { [k: string]: any } = {};
    Object.keys(obj).forEach((k) => {
        if (keys.indexOf(k as K) !== -1) return;
        ret[k] = (obj as any)[k];
    });
    return ret as Pick<T, Exclude<keyof T, K>>;
}
